var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6124821,15.4914064 C18.7934936,13.8786201 19.4999127,11.8976094 19.4999127,9.75003636 C19.4999127,4.37405124 15.1258869,-5.00000006e-08 9.74993308,-5.00000006e-08 C4.37397923,-5.00000006e-08 -5.00000006e-08,4.37405124 -5.00000006e-08,9.75003636 C-5.00000006e-08,15.1260215 4.37402579,19.5000727 9.74997962,19.5000727 C11.8975401,19.5000727 13.8787256,18.7935565 15.4915024,17.612538 L21.8789274,23.9999999 L23.9999999,21.878915 C23.9999999,21.8788685 17.6124821,15.4914064 17.6124821,15.4914064 L17.6124821,15.4914064 Z M9.74997962,16.5000437 C6.0278145,16.5000437 3.0000116,13.4722231 3.0000116,9.75003636 C3.0000116,6.02784958 6.0278145,3.00002906 9.74997962,3.00002906 C13.4721448,3.00002906 16.4999477,6.02784958 16.4999477,9.75003636 C16.4999477,13.4722231 13.4720982,16.5000437 9.74997962,16.5000437 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/zoom.5b4c0ed05449adf353c2df4efe320e6c.svg";
export { ForwardRef as ReactComponent };